import Vue from 'vue';
import VueSocketio from 'vue-socket.io';
import Config from '../lib/plugins/config';

Vue.use(VueSocketio, Config.get('socket_io_url'));



// WEBPACK FOOTER //
// ./node_modules/@triotech/vue-core/src/vendor/socket-io.js